var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightTheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 1.3,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 1.2,
    x2: 8,
    y2: 3.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12.8,
    x2: 8,
    y2: 14.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.2,
    y1: 8,
    x2: 3.2,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.8,
    y1: 8,
    x2: 14.8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.4,
    y1: 3.4,
    x2: 4.8,
    y2: 4.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.2,
    y1: 11.2,
    x2: 12.6,
    y2: 12.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.4,
    y1: 12.6,
    x2: 4.8,
    y2: 11.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.2,
    y1: 4.8,
    x2: 12.6,
    y2: 3.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTheme);
export default __webpack_public_path__ + "static/media/LightTheme.4b41fbad32831260fcee199d2d5d1f47.svg";
export { ForwardRef as ReactComponent };